module.exports = __webpack_public_path__ + "img/10.f2997b98.jpg";